import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spaces_user = _resolveComponent("spaces-user")!
  const _component_spaces_group = _resolveComponent("spaces-group")!
  const _component_spaces_user_transition = _resolveComponent("spaces-user-transition")!
  const _component_app_skeleton_contact = _resolveComponent("app-skeleton-contact")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!

  return (_openBlock(), _createBlock(_component_app_item_wrapper, null, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$localize(_ctx.customTitle) || _ctx.$localize('contacts.outcoming.title')), 1)
    ]),
    control: _withCtx(() => [
      (_ctx.toShowViewAll)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAll = !_ctx.showAll)),
            class: "more-link"
          }, _toDisplayString(_ctx.showAll ? _ctx.$localize('drive.section.button.less_all') : _ctx.$localize('drive.section.button.view_all')), 1))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(() => [
      (!_ctx.skeleton)
        ? (_openBlock(), _createBlock(_component_spaces_user_transition, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outgoing, (request) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (request.user)
                    ? (_openBlock(), _createBlock(_component_spaces_user, {
                        key: request.user?.accountId,
                        user: request.user,
                        userType: _ctx.NETWORK_CONTACT_TYPES.OUTCOMING
                      }, null, 8, ["user", "userType"]))
                    : _createCommentVNode("", true),
                  (request.targetType === 'GROUP')
                    ? (_openBlock(), _createBlock(_component_spaces_group, {
                        key: request?.id,
                        group: request,
                        groupType: _ctx.NETWORK_CONTACT_TYPES.OUTCOMING,
                        onOpenGroup: _ctx.openGroupInfo
                      }, null, 8, ["group", "groupType", "onOpenGroup"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_app_skeleton_contact),
            _createVNode(_component_app_skeleton_contact)
          ], 64))
    ]),
    _: 1
  }))
}